<h2 class="my-3" [innerHTML]="'common-session-expired' | translate"></h2>
<button class="btn btn-primary w-100 mt-5" routerLink="/" [innerHTML]="'common-redirect-to-login' | translate"></button>